export default {
  profile: '个人信息',
  logout: '退出登录',
  admin: '管理员',
  accontCenter: '账号中心',
};
